import React from "react";
import RemoveButton from "./RemoveButton";
import MoveButton from "./MoveButton";
import EditButton from "./EditButton";

const DELTA_UP = -1;
const DELTA_DOWN = 1;

/**
 * <SequenceableControls editMode={}
 *   removeItem={}
 *   item={}
 *   itemIndex={}
 *   handleChange={}
 *   maxSequence={}
 *   type={}
 *   plType={}
 *   unitIndex={} (for unit_descendants)
 *   stateKey={} (for items updated with updateInHash function)
 * >
 */
const SequenceableControls = (props) => {
  try {
    const {
      editMode,
      type,
      plType,
      item,
      itemIndex,
      unitIndex,
      maxSequence,
      handleChange,
      removeItem,
      stateKey,
    } = props;

    item.index = itemIndex;
    item.unitIndex = unitIndex;
    item.stateKey = stateKey;

    return editMode ? (
      <div className="d-flex justify-content-right align-items-center">
        <div className="p-1">
          {props.focus ? <EditButton {...props} /> : ""}
          <RemoveButton
            removeItem={(e) =>
              removeItem(
                {
                  type: type,
                  id: item.id,
                },
                e
              )
            }
          />
        </div>
        <div className="p-1">
          <MoveButton
            delta={DELTA_UP}
            handleChange={handleChange}
            moveItem={item}
            maxSequence={maxSequence}
            type={type}
            plType={plType}
          />
          <MoveButton
            delta={DELTA_DOWN}
            handleChange={handleChange}
            moveItem={item}
            maxSequence={maxSequence}
            type={type}
            plType={plType}
          />
        </div>
      </div>
    ) : (
      ""
    );
  } catch (e) {
    console.error(e);
  }
};

export default SequenceableControls;
